/**
 * Based on https://github.com/grafana/grafana/blob/27835f373e581430aab7763eb08075fb308c8353/public/app/core/utils/datemath.ts
 */

import moment from "moment";

const units = new Set(["y", "M", "Q", "w", "d", "h", "m", "s"]);

export function parse(text, roundUp = false) {
    if (!text) {
        return void 0;
    }
    if (moment.isMoment(text)) {
        return text;
    }
    
    let time;
    let mathString = "";
    let index;
    let parseString;
    
    if (text.substring(0, 3) === "now") {
        time = moment.utc();
        mathString = text.substring("now".length);
    } else {
        index = text.indexOf("||");
        if (index === -1) {
            parseString = text;
            mathString = ""; // nothing else
        } else {
            parseString = text.substring(0, index);
            mathString = text.substring(index + 2);
        }
        time = moment.utc(parseString, moment.ISO_8601);
    }
    
    if (!mathString.length) {
        if (roundUp === "start") {
            return time.startOf("day");
        }
        return time.endOf("day");
    }
    
    return parseDateMath(mathString, time, roundUp);
}

function parseDateMath(mathString, time, roundUp) {
    const dateTime = time;
    let i = 0;
    const len = mathString.length;
    
    while (i < len) {
        const c = mathString.charAt(i++);
        
        let type;
        switch (c) {
        case "/": {
            type = 0;
        
            break;
        }
        case "+": {
            type = 1;
        
            break;
        }
        case "-": {
            type = 2;
        
            break;
        }
        default: {
            return void 0;
        }
        }
    
        let num;
        if (Number.isNaN(Number(mathString.charAt(i)))) {
            num = 1;
        } else if (mathString.length === 2) {
            num = mathString.charAt(i);
        } else {
            const numFrom = i;
            while (!Number.isNaN(Number(mathString.charAt(i)))) {
                i++;
                if (i > 10) {
                    return void 0;
                }
            }
            num = Number.parseInt(mathString.substring(numFrom, i), 10);
        }
        
        if (type === 0 // rounding is only allowed on whole, single, units (eg M or 1M, not 0.5M or 2M)
            && num !== 1) {
            return void 0;
        }
        const unit = mathString.charAt(i++);
        
        if (!units.has(unit)) {
            return void 0;
        }
        
        if (type === 0 && roundUp === "start") {
            dateTime.startOf(unit);
        } else if (type === 0 && roundUp === "end") {
            dateTime.endOf(unit);
        } else if (type === 1) {
            dateTime.add(num, unit);
        } else if (type === 2) {
            dateTime.subtract(num, unit);
        }
        
        if (roundUp === "start") {
            dateTime.startOf("day");
        } else if (roundUp === "end") {
            dateTime.endOf("day");
        }
    }
    
    return dateTime;
}
